import React from "react";
// Components
import DirectoryBreadCrumb from "view/components/Breadcrumbs/DirectoryBreadCrumb";
import { PageHeading } from "./components";
import { useDispatch } from "react-redux";
import { openDataPortalDrawer } from "store/modals";

// Generating URLs

const generateDynamicBreadcrumbLinks = () => {
  switch (true) {
    default:
      return [{ path: `/data-portal`, label: `Data Portal` }];
  }
};
export const Header = () => {
  const dispatch = useDispatch();
  const dynamicCommunityLinks = generateDynamicBreadcrumbLinks();
  return (
    <div className="flex items-start self-stretch justify-start flex-grow-0 flex-shrink-0">
      <div className="flex items-start self-stretch justify-start flex-grow">
        <div className="flex flex-col items-start justify-start flex-grow gap-2">
          <DirectoryBreadCrumb links={dynamicCommunityLinks} />
          <div className="flex items-start self-stretch justify-start flex-grow-0 flex-shrink-0 gap-2">
            <PageHeading parentName={""} />
          </div>
        </div>
      </div>
      <div className="flex justify-end items-end h-full">
        <button
          onClick={() =>
            dispatch(openDataPortalDrawer({ dataPortal: null, isEdit: false }))
          }
          className="flex justify-center items-center flex-grow-0 flex-shrink-0 gap-1.5 px-5 py-1 rounded-3xl border-2 border-primary dark:border-borderSilverBlue hover:bg-primaryExtraLight dark:bg-secondaryLight dark:hover:bg-primary_8 dark:hover:border-primary group transition"
        >
          <div className="flex justify-center items-center relative pt-1.5 pb-[7px] ">
            <p className="flex-grow-0 flex-shrink-0 text-base font-semibold text-center text-primary dark:text-primaryOutlined dark:group-hover:text-primary">
              Add File
            </p>
          </div>
        </button>
      </div>
    </div>
  );
};
